/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-27 16:02:16
 * @LastEditors: K
 * @LastEditTime: 2022-10-09 09:27:30
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  notification,
  Radio,
  Row,
  Select,
  Space,
  Tag,
} from 'antd'
import moment from 'moment'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { ThemeContext } from '../../theme/ThemeContext'
import { getPatientLabels } from '../patient/list/patientListSlice'
import styles from './MembersManagementPage.module.css'
import {
  getAddMembersOperation,
  getMemberCardSearchList,
  getMembersDetail,
} from './MembersManagementPageSlice'
// import { getPatientList } from '../../services/patient';
import {
  getPatientDetail,
  getPatientList,
  selectPatients,
} from '../registration/register/registerSlice'
import { CloseCircleFilled, SearchOutlined } from '@ant-design/icons'
import { getGenderName } from '../../models/user'
import { getAge } from '../../utils/StringUtils'
import { getMaskPhone } from '../../models/phone'
interface AddMembersModalProps {
  QXData?: any
  visible: boolean
  btnType: boolean
  onCancel: () => void
  onOk: (data: any) => void
  editId?: any
}

export const AddMembersModal = ({
  QXData,
  visible,
  btnType,
  onCancel,
  onOk,
  editId,
}: AddMembersModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const { CheckableTag } = Tag

  const { Option } = Select

  const { TextArea } = Input

  const theme = useContext(ThemeContext)

  const [detail, setDetail] = useState<any>()

  const [labelList, setLabelList] = useState<any>([])

  const [selectedTags, setSelectedTags] = useState<string[]>([])

  const [operation, setOperation] = useState<any>([])

  const [btnLoading, setBtnLoading] = useState(false)

  const [memberCardData, setMemberCardData] = useState<any>([])

  const [phoneInfo, setPhoneInfo] = useState<any>({})

  const [
    isPatientNameOverlayVisible,
    setIsPatientNameOverlayVisible,
  ] = useState(false)

  const [keyword, setKeyword] = useState('')

  const [keywords, setKeywords] = useState('')

  const [patientPhone, setPatientPhone] = useState<any>({})

  const patients = useSelector(selectPatients)

  const patientOverlay = (
    <Menu style={{ maxHeight: 360, overflow: 'auto' }}>
      {patients.map((p) => (
        <Menu.Item
          key={p.id}
          onClick={() => {
            form.setFieldsValue({
              patientId: p.id,
              memberName: p.name,
              memberPhone: p.phone ? (!QXData ? getMaskPhone(p?.phone) : p?.phone ) : '',
              sexType: String(p.sex),
              ageMonth: p.ageMonth,
              age: p.ageYear,
              birthday: p.birthday,
            })
            setKeywords(p.name)
            setPhoneInfo({
              memberPhone: p?.phone,
              phoneDisabled: p?.phone && !QXData,
            })
            setIsPatientNameOverlayVisible(false)
          }}
        >
          <Space>
            <span>{p.name}</span>
            <span>{getGenderName(p.sex)}</span>
            <span>{getAge(p.ageYear, p.ageMonth, '岁')}</span>
            <span>{p.phone ? (!QXData ? getMaskPhone(p?.phone) : p?.phone ) : ''}</span>
            <span>{p.id}</span>
          </Space>
        </Menu.Item>
      ))}
    </Menu>
  )

  const updateBirthday = () => {
    if (form) {
      const year = parseInt(form.getFieldValue('age')) || 0
      const month = parseInt(form.getFieldValue('ageMonth')) || 0
      if (year !== 0 || month !== 0) {
        const months = year * 12 + month
        const birthday = moment()
          .subtract(months, 'months')
          .format('YYYY/MM/DD')
        form.setFieldsValue({ birthday })
      }
    }
  }

  const updateYearsAndMonths = (birthday?: any) => {
    if (form) {
      const date = moment(birthday) || moment(form.getFieldValue('birthday'))
      if (!date.isValid()) {
        return
      }
      const duration = moment.duration(moment().diff(date))
      if (duration.years() < 0 || duration.months() < 0) {
        return
      }
      form.setFieldsValue({
        ageYear: duration.years(),
        age: duration.years(),
        ageMonth: duration.months() == 0 ? 1 : duration.months(),
      })
    }
  }

  useEffect(() => {
    if (visible) {
      getDataList()
    }else{
      setPatientPhone({})
    }
  }, [visible])

  const getDataList = (v?: any) => {
    dispatch(
      getMemberCardSearchList({
        param: v,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setMemberCardData(res.records)
        if (res?.records?.length) {
          if (res?.records?.length == 1) {
            form.setFieldsValue({
              memberCardId: res.records[0].cardNo,
              balance: res.records[0].balance,
            })
          }
        } else {
          form.setFieldsValue({
            balance: '',
          })
        }
      })
  }

  useEffect(() => {
    setBtnLoading(false)
  }, [btnType])
  useEffect(() => {
    if (!visible) {
      form.resetFields()
      setKeywords('')
      setSelectedTags([])
      setDetail({})
      setPhoneInfo({})
      setIsPatientNameOverlayVisible(false)
    } else {
      dispatch(getPatientLabels({ current: 1, size: 50 }))
        .then(unwrapResult)
        .then((res: any) => setLabelList(res))
    }
  }, [visible])

  useEffect(() => {
    if (visible) {
      dispatch(getPatientList(keyword || keywords))
    }
  }, [dispatch, keyword, keywords, visible])

  useEffect(() => {
    if (visible) {
      if (editId) {
        dispatch(getMembersDetail(editId))
          .then(unwrapResult)
          .then((v: any) => {
            setDetail(v)
            setKeywords(v?.memberName)
            setSelectedTags(v?.labelIds ? v?.labelIds?.split(',') : [])
            updateYearsAndMonths(v?.birthday)
            setPhoneInfo({
              memberPhone: v?.memberPhone,
              phoneDisabled: v?.memberPhone && !QXData,
            })
            form.setFieldsValue({
              memberName: v?.memberName,
              memberPhone: v?.memberPhone ? (!QXData ? getMaskPhone(v?.memberPhone) : v?.memberPhone ) : '',
              sexType: v?.sexType?.toString(),
              createUser: undefined,
              birthday: v?.birthday,
              balanceMoney: v?.balanceMoney,
              remarks: v?.remarks
            })
            dispatch(getAddMembersOperation())
              .then(unwrapResult)
              .then((res: any) => {
                setOperation(res)
                const data = res?.find(
                  (val: any) => val?.userId == v?.createUser
                )
                form.setFieldsValue({
                  createUser: data != undefined ? v?.createUser : undefined,
                })
              })
          })
      } else {
        dispatch(getAddMembersOperation())
          .then(unwrapResult)
          .then((res: any) => setOperation(res))
        form.setFieldsValue({
          balanceMoney: '0',
          createUser: Number(
            JSON.parse(localStorage.getItem('credentials') || '{}')?.userId
          ),
        })
      }
    }
  }, [visible, editId])

  return (
    <Modal
      visible={visible}
      title={editId ? '编辑会员' : '新增会员'}
      width={700}
      cancelText='取消'
      okText='确定'
      confirmLoading={btnLoading}
      maskClosable={false}
      destroyOnClose
      onCancel={() => {
        setIsPatientNameOverlayVisible(false)
        onCancel()
      }}
      onOk={form.submit}
      bodyStyle={{ height: 560, overflow: 'auto' }}
    >
      <Form
        form={form}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 19 }}
        autoComplete='off'
        onFinish={(values) => {
          const res = /(^[0-9]*\.([0-9]{1}\d*)$)|(^[0-9]*$)/
          if (!editId) {
            if (!res.test(values.balanceMoney)) return
          }
          const memberCard = memberCardData.find((item: any) => item.cardNo == values.memberCardId)
          if (values.memberCardId != memberCard?.cardNo) {
            notification.error({
              message: '卡号不正确，请重新输入会员卡号',
            })
            return
          }
          const cardNo = memberCard?.cardNo
          setBtnLoading(true)
          onOk({
            ...detail,
            ...values,
            memberPhone: values?.memberPhone == getMaskPhone(values?.memberPhone) ? phoneInfo?.memberPhone : values?.memberPhone || '',
            memberName: (values.memberName || keywords || '').trim(),
            patientId: form.getFieldValue('patientId') || undefined,
            age: values.birthday ? moment(values.birthday).format('YYYY/MM') : undefined,
            ageYear: parseInt(values.age) || undefined,
            ageMonth: parseInt(values.ageMonth) || undefined,
            cardNo: cardNo ? cardNo : undefined,
            balance: undefined,
            memberCardId: undefined
          })
        }}
      >
        <Form.Item label='姓名' name='memberName' rules={[{ required: true }]}>
          <Dropdown
            overlay={patientOverlay}
            visible={isPatientNameOverlayVisible}
            onVisibleChange={((v) => {
              setIsPatientNameOverlayVisible(v)
            })}
          >
            <Input
              allowClear
              placeholder='请输入姓名'
              prefix={<SearchOutlined style={{ color: theme.tc3 }} />}
              value={keywords}
              onFocus={() => {
                dispatch(getPatientList(keywords))
                setIsPatientNameOverlayVisible(true)
              }}
              onBlur={() => {
                setTimeout(() => {
                  setIsPatientNameOverlayVisible(false)
                }, 300)
              }}
              onClick={() => {
                setIsPatientNameOverlayVisible(true)
              }}
              onChange={(e) => {
                setIsPatientNameOverlayVisible(true)
                setKeywords(e.target.value)
                setKeyword('')
                form.setFieldsValue({ memberName: e.target.value, patientId: undefined })
              }}
            />
          </Dropdown>
        </Form.Item>
        <Form.Item
          label='手机号'
          name='memberPhone'
          rules={[
             phoneInfo?.phoneDisabled ? {} : {
              required: true,
              pattern: new RegExp(/^1[3|4|5|6|7|8|9][0-9]\d{8}$/),
              message: '请输入正确的会员手机号码',
            },
          ]}
        >
          <Input
            placeholder='请输入手机号'
            disabled={phoneInfo?.phoneDisabled}
            suffix={
              phoneInfo?.phoneDisabled ? (
                <CloseCircleFilled
                  onClick={() => {
                    form.setFieldsValue({ memberPhone: '' })
                    setPhoneInfo({
                      phone: '',
                      phoneDisabled: false,
                    })
                  }}
                  style={{ color: '#999', cursor: 'pointer' }}
                />
              ) : null
            }
          />
        </Form.Item>
        <Form.Item label='性别' name='sexType' rules={[{ required: true }]}>
          <Radio.Group>
            <Radio value='1'>男</Radio>
            <Radio value='2'>女</Radio>
            <Radio value='0'>未知</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label='年龄'>
          <Row wrap={false} align='middle'>
            <Form.Item
              name='age'
              noStyle
              dependencies={['ageMonth']}
              rules={[
                {
                  pattern: /^\d{0,3}$/,
                  message: '请输入正确的年龄',
                },
              ]}
            >
              <Input onChange={updateBirthday} style={{ maxWidth: '3rem' }} />
            </Form.Item>
            <div
              style={{
                color: theme.tc2,
                fontSize: '1rem',
                margin: '0 6px',
              }}
            >
              岁
            </div>
            <Form.Item
              name='ageMonth'
              noStyle
              dependencies={['ageYear']}
              rules={[
                {
                  pattern: /^(|0?[0-9]|1[0-1])$/,
                  message: '请输入正确的月份',
                },
              ]}
            >
              <Input
                // readOnly={hasCard}
                // onClick={() => readMessage()}
                onChange={updateBirthday}
                style={{ maxWidth: '3rem' }}
              />
            </Form.Item>
            <div
              style={{
                color: theme.tc2,
                fontSize: '1rem',
                margin: '0 6px',
              }}
            >
              月
            </div>
            <Form.Item
              name='birthday'
              noStyle
              style={{ flex: 1 }}
              rules={[
                { max: 16, message: '最多16个字' },
                {
                  pattern: /^(|\d{4}\/\d{1,2}\/\d{1,2})$/,
                  message: '年龄格式为YYYY/MM/DD',
                },
              ]}
            >
              <Input
                onChange={(v) => {
                  updateYearsAndMonths(v?.target?.value)
                }}
              // readOnly={hasCard}
              // onClick={() => readMessage()}
              />
            </Form.Item>
          </Row>
        </Form.Item>
        <Form.Item label='生日' name='birthday'>
          <Input />
        </Form.Item>
        <Form.Item label='标签' name='labelIds'>
          {labelList.map((item: any) => (
            <CheckableTag
              style={{
                marginBottom: 5,
                border: '1px solid #d2d2d2',
                borderRadius: 3,
              }}
              key={item.id}
              checked={selectedTags.indexOf(item.id) > -1}
              onChange={(checked: any) => {
                const nextSelectedTags = checked
                  ? [...selectedTags, item.id]
                  : selectedTags.filter((t) => t !== item.id)
                form.setFieldsValue({
                  labelIds: nextSelectedTags.join(','),
                })
                setSelectedTags(nextSelectedTags)
              }}
            >
              {item.name}
            </CheckableTag>
          ))}
        </Form.Item>
        {editId ? (
          <></>
        ) : (
          <Form.Item
            label='储值金'
            name='balanceMoney'
            rules={[
              { required: true, message: '储值金不能为空' },
              {
                pattern: new RegExp(/(^[0-9]*\.([0-9]{1}\d*)$)|(^[0-9]*$)/),
                message: '请输入正确的的数字',
              },
            ]}
          >
            <Input suffix={<div className={styles.iptText}>元</div>} />
          </Form.Item>
        )}
        <Form.Item
          label='绑定实体卡'
          name='memberCardId'
        >
          <Input
            allowClear
            placeholder='请刷卡/输入实体卡卡号'
            prefix={<SearchOutlined style={{ color: theme.tc3 }} />}
            onChange={(e: any) => {
              getDataList(e.target.value)
            }}
          />
        </Form.Item>
        <Form.Item
          label='会员卡金额'
          name='balance'
        >
          <Input placeholder='请输入会员卡金额' disabled />
        </Form.Item>
        <Form.Item label='操作员' name='createUser' rules={[
          {
            required: true,
            message: '操作员不能为空',
          },
        ]}>
          <Select>
            {operation.length &&
              operation.map((v: any) => (
                <Option key={v.userId} value={v.userId}>
                  {v.userName}
                </Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item label='备注' name='remarks'>
          <TextArea showCount maxLength={100} />
        </Form.Item>
      </Form>
    </Modal >
  )
}
